<template>

    <div>

        <v-card class="pa-3 yellow lighten-3" dense>       
              
         
            <v-toolbar class="py-0 my-0 mb-4" color="pa-3 yellow lighten-3">
                
                    <v-spacer></v-spacer> 

                    <v-toolbar-title class="my-0 py-0 text-center" style="color: red; font-weight: bold;">
                        Remito Temporal Número {{ datos.numero }}
                    </v-toolbar-title>

                    <v-spacer></v-spacer> 
                    
                    <div>
                        <v-btn icon @click="imprimirPDF" color="primary">
                        <v-icon>mdi-printer</v-icon>
                        </v-btn>
                    </div>

            </v-toolbar>
           
              

              
            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                                
                <v-row  dense  class="py-0 my-0" >

                    <v-col cols="4" sm="4" md="4"  dense>
                        Fecha Remito: {{ datos.fecha.slice(0, 10) }}
                    </v-col>
                    <v-col cols="4" sm="4" md="4" dense>
                        Cliente: {{ datos.codigo }} - {{ datos.nombre }}
                    </v-col>
                    <v-col  cols="4" sm="4" md="4"  dense class="text-right">
                        Resp. Comercial: {{ datos.usuario }}
                    </v-col>

                </v-row>  
                
                <v-row  dense  class="py-0 my-0" >

                    <v-col cols="4" sm="4" md="4"  dense>
                        Orden de Compra: {{ datos.ordencompra }}
                    </v-col>

                    <v-col cols="2" sm="2" md="2"  dense>
                        Envio: {{ datos.envio }}
                    </v-col>


                    <v-col cols="2" sm="2" md="2"  dense>
                        Cant. Camiones: {{ datos.cantcamion }}
                    </v-col>

                </v-row>
                                
                
            </v-card>    

            <div></div>

            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                <v-row>
                    <v-col cols="12" sm="12" md="12">

                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            dense
                            :items-per-page.sync="itemsPerPage"
                            :footer-props="{
                            itemsPerPageText: 'Items por página',
                            }"

                        ></v-data-table>

                    </v-col>
                </v-row>
                
            </v-card>

            <div></div>               
            <v-card class="pa-2 yellow lighten-4 mt-4" dense >
                <v-row>

                </v-row>
                <v-row>
                    <v-col cols="auto">
                        Observación: {{ datos.observa }}
                    </v-col>
                </v-row>
                
            </v-card>
           

            </v-card>

    </div>


  
  </template>
  
  <script>

  import readXlsFile from "read-excel-file";
  import Axios from "../../axios-auth-sistemas";

  import BuscadorClientes from "../Comercial/BuscadorClientes.vue"; 


  import moment from "moment";

  import jsPDF from "jspdf"; 
  import "jspdf-autotable";




  
  export default {

    name:'RemitoLink',

    data() {
      return {
        headers: [
          { text: "Item", value: "item" },
          { text: "Cantidad", value: "cantidad" },
          { text: "Articulo", value: "articulo" },
          { text: "Camion", value: "camion" },
          { text: "Descripción", value: "detalle" },
        
        ],
        headersAux: [
          { text: "Item", value: "item" },
          { text: "Cantidad", value: "cantidad" },
          { text: "Articulo", value: "articulo" },
          { text: "Camion", value: "camion" },
          { text: "Descripción", value: "detalle" },
        ],
        excelData: [],
        codigoCli:'',
        nombreCli:'',
        cuitCli:'',
        showBuscadorCli:false,
        showFlags:'',
        CodigoSele:'',
        editMode:false,
        dessertAux:[],
        vAlert:'',
        activar:false,
        validacionExitosa: true, 
        fileInput:'',
        dialogCorreo:false,
        direcciones: [],
        direccion: "",
        correos: "",
        mailSel:"",
        vNumRto:'',
        vRtoGral:'',
        datos:{
            codigo:'',
            detalle:'',
            numero:'',
            fecha:'',
            usuario:'',
            ordencompra:'',
            envio:'',
            cantcamion:''

        },
        desserts:[],
        visible:true,
        itemsPerPage:-1,




      };
    },


    computed: {

        show: {
            get() {        
    
            return this.visible;
            },
        } 

    },
    watch: {
        
       
    } ,   

    mounted() {

       console.log("estoy en remito link")
        this.vRtoGral = this.$route.query.codgral;
        this.cargarRemito(this.vRtoGral);

    },


    methods: { 

        salir(){
            this.visible=false;
        },

       cargarRemito(id){

            console.log("id", id)
            Axios
            .get("/ComercialVentas/MostrarRemitoTemp?", {
            params: {
                id: id                 
            },
            })
            .then((r) => { 

                console.log("datos",r.data)

                this.datos.codigo = r.data[0].codigo;
                this.datos.nombre = r.data[0].nombre;
                this.datos.numero = r.data[0].numero;
                this.datos.fecha = r.data[0].fecha;
                this.datos.usuario = r.data[0].usuario;
                this.datos.observa = r.data[0].observacion;
               
            

                r.data.forEach(element => {

                    if (element.cantidad > 0)
                    {

                        if (element.oc != null){
                            this.datos.ordencompra =element.oc;
                        }

                        if (element.envio != null){
                            this.datos.envio =element.envio;
                        }

                        if (element.cantCamion != null){
                            this.datos.cantcamion =element.cantCamion;
                        }


                    }
                    
                    this.desserts.push({
                        item: element.cantidad ==0 ? '' : element.item ,
                        articulo: element.articulo,
                        camion:element.item ==0 || element.item == '' ? '' : element.camion,
                        detalle: element.detalle,
                        cantidad: element.cantidad ==0 ? '' : element.cantidad,

                    })
                });

              

               

                    
                    
                    
                    
            })
            .catch((error) => {
                console.log("no muestra el remmito cuando hace link")      
                
                            
            }); 



       },


       imprimirPDF(){

            var vm = this;      
            var columns = [

            {title: "Item", dataKey: "item"},
            {title: "Cantidad", dataKey: "cantidad"},  
            {title: "Articulo", dataKey: "articulo"},
            {title: "Camion", dataKey: "camion"},
            {title: "Descripcion", dataKey: "detalle"},           
                    
          
           


            ];
            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);           
            doc.line(10, 11, 10, 41);
            doc.line(165, 24, 200, 24);
           // doc.line(165, 33, 200, 33);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(13);
            doc.text("REMITO TEMPORAL" , 75, 20);

            doc.setFontSize(11);
            doc.text("CLIENTE: " + vm.datos.codigo + ' - ' + vm.datos.nombre   , 42, 30);

            doc.setFontSize(9);
            doc.text("O.COMPRA: " + vm.datos.ordencompra   , 42, 40);

            doc.setFontSize(9);
            doc.text("ENVIO: " + vm.datos.envio   , 90, 40);

            doc.setFontSize(9);
            doc.text("CANT. CAMIONES:  " + vm.datos.cantcamion   , 120, 40);

            doc.setFontSize(13);
            doc.text("N° " + vm.datos.numero , 166, 20);
                 
           
            doc.setFontSize(10);
            doc.text(vm.datos.fecha.slice(0,10) , 166, 30);
       
           
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);


            doc.autoTable(columns, this.desserts, { 
        
            startY: 45,
            margin: { top: 25, left: 10 , right: 10},
            styles: { fontSize: 7 }
            
            });



            var finalO =  doc.autoTable.previous.finalY + 30;

            if (finalO >= 285) {
                doc.addPage();
                finalO = 0;
            }



            doc.setFontSize(10);

            doc.text("Observacion:  "+ vm.datos.observa, 10,finalO + 10);


            var finalO1 =  doc.autoTable.previous.finalY + 30;

            if (finalO1 >= 285) {
                doc.addPage();
                finalO1 = 0;
            }

          
            doc.text("Responsable Comercial:  "+ vm.datos.usuario, 10,finalO1 + 20);

           
            finalO = finalO + 40;
        
            
   

            const pageCount = doc.internal.getNumberOfPages();

            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                "Página " + String(i) + " de " + String(pageCount),
                210 - 20,
                297 - 10,
                null,
                null,
                "right"
                );
            }

            doc.save('table.pdf');


       },





    },
  };
  </script>
  
  <style scoped>
  
  </style>
  